/* ============================================================================
   LOVI — LOT 16 (06/08/2026)   theme 198702203207 (V10, UNPUBLISHED)

   UNE SEULE CHOSE ICI : le raccourcissement du texte du bloc « 8 plantes ».
   Tout le reste du lot 16 est en CSS (assets/lovi-lot16.css).

   POURQUOI DU JS. Le texte vit dans sections/lovi-pdp-buybox.liquid (104 Ko).
   On ne repousse pas 104 Ko pour vingt-huit caracteres — meme raisonnement et
   meme point d'accroche que trimPayments() du lot 13.

   POURQUOI CE TEXTE-LA, ET PAS CELUI QUI ETAIT PROPOSE.
   Mesures (13px, interligne 1,45, largeur de colonne necessaire pour tenir en
   DEUX lignes, donc 3 lignes au total avec le titre) :
       texte actuel ................................................ 326px
       « Dont l'achillée millefeuille, contre les ballonnements.
         Tout est écrit sur la boîte. »  (version proposee) ......... 256px
       « Dont l'achillée millefeuille, traditionnellement utilisée
         contre les ballonnements. »     (version retenue) .......... 278px
   Largeur reellement disponible apres le passage en grille du CSS : 294px
   mesures a 360. Les deux versions tiennent donc. La version proposee est
   ecartee pour une raison qui n'est pas typographique : elle supprime
   « traditionnellement utilisée ».

   Les allegations botaniques sont « en attente » au sens du reglement
   1924/2006 depuis 2010 (voir references/reglementation.md du dossier de
   marque). « Traditionnellement utilisée contre les ballonnements » est un
   enonce d'usage traditionnel. « Contre les ballonnements » tout court est
   une allegation de sante directe sur une plante en attente. Les six mots
   retires par la version proposee sont exactement ceux qui tiennent la phrase
   du bon cote de la ligne — pour une ligne d'ecran gagnee, on prenait un
   risque de conformite sur la page de vente. On garde les six mots.

   Ce qui est retire a la place : « Tout est écrit sur la boîte. » — phrase
   deja portee ailleurs sur la page (l'USP « Chaque dose écrite sur la boîte »
   et le bloc expert la reprennent), donc la seule perte est une redondance.
   Le dossier de marque note d'ailleurs 24 994 caracteres rendus pour un
   contenu tres repetitif : retirer une redite est un gain, pas une perte.

   RESERVE AU MOBILE. Sur desktop la colonne fait 526px et le texte complet
   tient deja en 3 lignes (mesure) : on n'ampute pas la copy desktop. Le texte
   d'origine est conserve dans un data-attribut et remis en place si la fenetre
   repasse au-dessus de 767px, pour que la rotation d'un telephone ou le
   redimensionnement d'une fenetre ne laisse pas la version courte sur un
   affichage large.
   ========================================================================== */
(function () {
  if (window.__loviLot16) return;
  window.__loviLot16 = 1;

  var MQ = '(max-width:767px)';

  /* apostrophe droite ou typographique : le gabarit peut changer sans
     prevenir, la regex accepte les deux. */
  var LONG = /Dont\s+l['’]achill[ée]e\s+millefeuille,\s*traditionnellement\s+utilis[ée]e\s+contre\s+les\s+ballonnements\.\s*Tout\s+est\s+[ée]crit\s+sur\s+la\s+bo[îi]te\.?/i;

  var SHORT = 'Dont l’achillée millefeuille, traditionnellement '
            + 'utilisée contre les ballonnements.';

  function isMobile() {
    return window.matchMedia && window.matchMedia(MQ).matches;
  }

  function apply() {
    var els = document.querySelectorAll('.lovi-labcard__text');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];

      /* memorisation du texte d'origine, une seule fois */
      if (!el.hasAttribute('data-lovi16-full')) {
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!LONG.test(t)) continue;          /* pas le bloc vise : on sort */
        el.setAttribute('data-lovi16-full', t);
      }

      var full = el.getAttribute('data-lovi16-full');
      var want = isMobile() ? full.replace(LONG, SHORT) : full;
      var have = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (have !== want) el.textContent = want;
    }
  }

  /* rafraichissement au changement de largeur, sans ecouteur resize brut */
  function watch() {
    if (!window.matchMedia) return;
    var mql = window.matchMedia(MQ);
    if (mql.addEventListener) mql.addEventListener('change', apply);
    else if (mql.addListener) mql.addListener(apply);
  }

  apply();                                    /* le script est en fin de <body> */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(apply, 0); });
  } else {
    setTimeout(apply, 0);
  }
  window.addEventListener('load', apply);
  watch();
})();
